import buttonUp from '@/assets/btn/up.png';
import { Sound } from '@/classes';
import { keyCodes } from '@/constants';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { setFocus } from '@noriginmedia/norigin-spatial-navigation';
import { useCallback } from 'react';
import { scrollElementTo } from '@/utils';

export type ContentGroupDetailSidebarProps = {
  scrollingRef: React.MutableRefObject<HTMLDivElement | null>;
  targetFocusKey: string;
};

export const ContentGroupDetailSidebar = ({ scrollingRef, targetFocusKey }: ContentGroupDetailSidebarProps) => {
  const { ref, focused } = useExtendFocusable({
    saveLastFocusedChild: true,
    trackChildren: true,
    autoRestoreFocus: true,
  });

  const handleOnClick = useCallback(() => {
    if (!scrollingRef) return;

    Sound.press();
    if (scrollingRef?.current) {
      scrollElementTo({ element: scrollingRef.current, top: 0 });
    }

    if (targetFocusKey) {
      setFocus(targetFocusKey);
    }
  }, [scrollingRef, targetFocusKey]);

  useFocusElement({ ref, focused, onClick: handleOnClick, keyCode: keyCodes.ENTER });

  return (
    <div className="fixed flex w-[169px] h-[900px] items-center justify-center outline-disable" ref={ref} tabIndex={0}>
      <div
        className="box-shadow-lg shadow-gray-400 fixed bg-[#FFF3F9] rounded-full p-3 outline-disable outline-primary-fill-8"
        style={{
          ...(focused ? { boxShadow: '0 0 0 8px #ff66af, 0px 4px 4px 8px rgba(0, 0, 0, 0.12)' } : {}),
        }}
        onClick={handleOnClick}
        onContextMenu={handleOnClick}
      >
        <img src={buttonUp} className={`w-auto h-auto`} />
      </div>
    </div>
  );
};
